import { useCallback, useRef } from "react";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { getCountryFromPlace } from "../utils/LocationUtils";
import { COUNTRIES_SHORT, getCountryId } from "../enums/Countries";
import { TextInput } from "react-admin";
import { validateRequired } from "../utils/Validations";
import { useFormContext } from "react-hook-form";

const libraries = ["places"];

const AddressAutocomplete = (props) => {
  const { setValue } = useFormContext();
  const autocompleteRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GEOCODE_API_KEY,
    libraries,
  });

  const onPlaceChanged = useCallback(() => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      const address = place?.name;

      if (address) {
        const coords = place.geometry.location;
        const lat = coords.lat();
        const lng = coords.lng();
        // Set the address and location
        setValue("address", address);
        setValue("location[0]", lng);
        setValue("location[1]", lat);

        const countryName = getCountryFromPlace(place);
        const countryId = getCountryId(countryName);
        setValue("country", countryId);
        props.setCountry?.(countryId);
      }
    }
  }, [setValue, props]);

  const onAutocompleteLoad = useCallback((autocompleteInstance) => {
    autocompleteRef.current = autocompleteInstance;
  }, []);

  return (
    <div className="relative">
      {isLoaded ? (
        <Autocomplete
          types={["route"]}
          onLoad={onAutocompleteLoad}
          onPlaceChanged={onPlaceChanged}
          apiKey={process.env.REACT_APP_GEOCODE_API_KEY}
          restrictions={{ country: Object.values(COUNTRIES_SHORT) }}
          fields={["name", "geometry", "address_components"]}
        >
          <TextInput
            source="address"
            label="Dirección"
            validate={validateRequired}
            fullWidth
            placeholder="Ingresa la dirección de tu local"
            onChange={(e) => {
              // Clear location data when user types manually
              setValue("location[0]", "");
              setValue("location[1]", "");
              setValue("region", "");
            }}
            {...props}
          />
        </Autocomplete>
      ) : (
        <TextInput
          source="address"
          label="Dirección"
          validate={validateRequired}
          fullWidth
          placeholder="Cargando..."
          readOnly
        />
      )}
    </div>
  );
};

export default AddressAutocomplete;
